var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1779",
    "data-name": "\\uC0AC\\uAC01\\uD615 1779",
    width: 17.187,
    height: 17.984,
    fill: "none",
    stroke: "#386a98",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_replay",
    transform: "translate(-3.489 -3.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_923",
    "data-name": "\\uADF8\\uB8F9 923",
    transform: "translate(3.489 3.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_64px_icon",
    "data-name": "64px icon",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_2",
    "data-name": "\\uC0AC\\uAC01\\uD615 2",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20V0H20V20Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19 19 L 19 1 L 1 1 L 1 19 L 19 19 M 20 20 L 0 20 L 0 0 L 20 0 L 20 20 Z",
    stroke: "none",
    fill: "#386a98"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1288",
    "data-name": "\\uADF8\\uB8F9 1288",
    transform: "translate(1.406 1.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1287",
    "data-name": "\\uADF8\\uB8F9 1287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_609",
    "data-name": "\\uD328\\uC2A4 609",
    d: "M2.68.5,2.094,3.156A5.894,5.894,0,1,1,.5,7.306",
    transform: "translate(2.202 2.202)",
    fill: "none",
    stroke: "#386a98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_117",
    "data-name": "\\uC120 117",
    x1: 2.441,
    y1: 0.379,
    transform: "translate(4.296 5.358)",
    fill: "none",
    stroke: "#386a98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReplay);
export default __webpack_public_path__ + "static/media/ico_replay.11056742200151b0ac7259385e772569.svg";
export { ForwardRef as ReactComponent };